import React, { useState } from "react";
import { VerticalTimelineElement } from "react-vertical-timeline-component";
import styled from "styled-components";

const Top = styled.div`
  width: 100%;
  display: flex;
  max-width: 100%;
  gap: 12px;
`;

const Image = styled.img`
  height: 50px;
  border-radius: 10px;
  margin-top: 4px;
  @media only screen and (max-width: 768px) {
    height: 40px;
  }
`;

const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const School = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

const Degree = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const Date = styled.div`
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.text_secondary};
  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

const Description = styled.div`
  width: 100%;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 10px;
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const Grade = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const Span = styled.div`
  display: -webkit-box;
  max-width: 100%;
`;

const ViewButton = styled.button`
  background-color: #1d1836;
  border: 2px solid transparent;
  border-image: linear-gradient(to right, #8e2de2, #4a00e0);
  border-image-slice: 1;
  color: #fff;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  margin-right: 10px;
  margin-top: 20px;
  &:hover {
    background-color: #1d1536;
    border: 2px solid transparent;
    border-image: linear-gradient(to right, #cccccc, #ffffff);
    border-image-slice: 1;
  }
`;

const EducationCard = ({ education }) => {
  // Button click handlers
  const handleViewInstitution = () => {
    window.open(education?.institutionUrl, "_blank");
  };

  const handleViewWebsite = () => {
    window.open(education?.websiteUrl, "_blank");
  };

  return (
    <VerticalTimelineElement
      icon={
        <img
          width="100%"
          height="100%"
          alt={education?.school}
          style={{ borderRadius: "50%", objectFit: "cover" }}
          src={education?.img}
        />
      }
      contentStyle={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        background: "#1d1836",
        color: "#fff",
        boxShadow: "rgba(23, 92, 230, 0.15) 0px 0px 40px 5px",
        backgroundColor: "rgba(17, 25, 40, 0.83)",
        border: "3px solid rgba(255, 255, 255, 0.15)",
        borderRadius: "6px",
        borderImage: "linear-gradient(to right, #8e2de2, #4a00e0) 1",
      }}
      contentArrowStyle={{
        borderRight: "10px solid rgba(255, 255, 255, 0.5)",
      }}
      date={education?.date}
    >
      <Top>
        <Image src={education?.img} />
        <Body>
          <School>{education?.school}</School>
          <Degree>{education?.degree}</Degree>
          <Date>{education?.date}</Date>
        </Body>
      </Top>
      <Grade>
        <b>Grade: </b>
        {education?.grade}
      </Grade>
      <Description>
        {education?.desc && <Span>{education.desc}</Span>}
      </Description>

      {/* Buttons to view institution and website */}
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {education?.institutionUrl && (
          <ViewButton onClick={handleViewInstitution}>
            View Institution
          </ViewButton>
        )}
        {education?.websiteUrl && (
          <ViewButton onClick={handleViewWebsite}>
            View Website
          </ViewButton>
        )}
      </div>
    </VerticalTimelineElement>
  );
};

export default EducationCard;
